import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-center gap-4 py-8",
  "data-cy": "statement-ready-alert"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-body-1 font-weight-bold mb-1" }
const _hoisted_4 = {
  class: "flex flex-wrap justify-center gap-3 mt-2",
  "data-cy": "post-generation-actions"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "text-center whitespace-pre-line" }
const _hoisted_7 = {
  class: "flex flex-col items-center py-8 gap-4",
  "data-cy": "polling-state"
}
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col items-center py-8 gap-4",
  "data-cy": "preview-loading-state"
}
const _hoisted_9 = {
  key: 3,
  class: "w-full border rounded mb-4 overflow-auto",
  style: {"max-height":"600px"},
  "data-cy": "statement-preview-pre"
}
const _hoisted_10 = { class: "flex gap-3 mt-2" }

import { computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import AlertBar from '@/components/AlertBar.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import { formatLongDateString } from '@/services/utils';
import { VuePdfEmbed } from '@/utils/pdfHelpers';


export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementStatementStep',
  props: {
  /** Number shown in the title — the parent renumbers when Map Payments is skipped. */
  stepNumber: { type: Number, default: 6 },
  /** Whether statement PDF has been generated and downloadUrl is set. */
  statementReady: { type: Boolean, default: false },
  /** Whether we are currently polling for the blobPath. */
  polling: { type: Boolean, default: false },
  /** Whether polling timed out without finding a blobPath. */
  timedOut: { type: Boolean, default: false },
  /** Whether the POST /statement/generate request is in-flight. */
  generating: { type: Boolean, default: false },
  /** Whether any save is in progress (used for retry button). */
  saving: { type: Boolean, default: false },
  /** Authenticated download URL for the PDF (non-null when statementReady). */
  downloadUrl: { type: String, default: null },
  /** ISO date string when the statement was generated (for post-gen display). */
  generatedDate: { type: String, default: null },
  /** Whether all prior steps are complete and generate is allowed. */
  canGenerate: { type: Boolean, default: true },
  /** Authenticated blob URL for the preview PDF (pre-generation inline display). */
  previewUrl: { type: String, default: null },
  /** Whether the preview PDF is being generated (POST in-flight). */
  previewGenerating: { type: Boolean, default: false },
  /** Whether we are polling for the preview blobPath. */
  previewPolling: { type: Boolean, default: false },
  /** Whether preview polling timed out. */
  previewTimedOut: { type: Boolean, default: false },
  /** Whether the settlement can be reset (from backend). */
  canReset: { type: Boolean, default: true },
  /** Reason the reset is blocked (shown as tooltip when canReset is false). */
  resetBlockedReason: { type: String, default: null },
},
  emits: [
  'retry-polling',
  'unlock-and-reset',
  'reprint',
  'download',
  'go-back',
  'generate', 'retry-preview',
],
  setup(__props) {

const props = __props;



const generatedDateFormatted = computed(() => {
  if (!props.generatedDate) return '';
  return formatLongDateString(props.generatedDate) || props.generatedDate;
});


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "border-0 !bg-[rgb(var(--v-theme-surface))]"
  }, {
    default: _withCtx(() => [
      (__props.statementReady)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pb-0" }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Settlement Complete", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "inline-flex items-center gap-1 px-4 py-1 rounded-full text-green-700 bg-green-100 text-sm font-medium" }, " ✓ Settlement Statement Generated ", -1)),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, " Statement generated on " + _toDisplayString(generatedDateFormatted.value), 1),
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-body-2 text-grey-darken-1" }, " This is the final settlement statement on file. You can reprint it or unlock to make changes and generate a new version. ", -1))
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(LlSecondaryButton, {
                      color: "primary",
                      "prepend-icon": "mdi-printer",
                      "data-cy": "reprint-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reprint')))
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Reprint Statement ", -1)
                      ]))]),
                      _: 1
                    }),
                    (__props.downloadUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: __props.downloadUrl,
                          download: "settlement-statement.pdf",
                          class: "text-decoration-none",
                          "data-cy": "download-pdf-link",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('download')))
                        }, [
                          _createVNode(LlSecondaryButton, { "prepend-icon": "mdi-download" }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode(" Download PDF ", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_5))
                      : _createCommentVNode("", true),
                    (!__props.canReset)
                      ? (_openBlock(), _createBlock(LlTooltip, {
                          key: 1,
                          location: "top"
                        }, {
                          activator: _withCtx(() => [
                            _createVNode(LlSecondaryButton, {
                              color: "orange",
                              "prepend-icon": "mdi-lock",
                              "data-cy": "unlock-reset-button",
                              disabled: ""
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode(" Unlock & Reset ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(__props.resetBlockedReason || 'Reset is not available'), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(LlSecondaryButton, {
                          key: 2,
                          color: "orange",
                          "prepend-icon": "mdi-lock-open",
                          "data-cy": "unlock-reset-button",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('unlock-and-reset')))
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createTextVNode(" Unlock & Reset ", -1)
                          ]))]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              _: 1
            })
          ], 64))
        : (__props.generating || __props.polling)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pb-0" }, {
                default: _withCtx(() => [
                  _createTextVNode("Step " + _toDisplayString(__props.stepNumber) + ": Generate Settlement Statement", 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "success",
                      size: "48"
                    }),
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-body-1 font-weight-medium" }, " Generating settlement statement… ", -1)),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-caption text-grey" }, " This usually takes a few seconds. Please wait. ", -1))
                  ])
                ]),
                _: 1
              })
            ], 64))
          : (__props.timedOut)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pb-0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Step " + _toDisplayString(__props.stepNumber) + ": Generate Settlement Statement", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(AlertBar, {
                      class: "mb-4",
                      "data-cy": "timeout-alert"
                    }, {
                      default: _withCtx(() => [
                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "font-weight-bold mb-1" }, "Still generating…", -1)),
                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mb-2 text-body-2" }, " The statement is taking longer than expected. The PDF may still be processing. ", -1)),
                        _createVNode(LlSecondaryButton, {
                          color: "warning",
                          loading: __props.saving,
                          "data-cy": "retry-polling-button",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('retry-polling')))
                        }, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode(" Check again ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold pb-0" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Step " + _toDisplayString(__props.stepNumber) + ": Generate Settlement Statement", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    (!__props.canGenerate)
                      ? (_openBlock(), _createBlock(AlertBar, {
                          key: 0,
                          class: "mb-4",
                          "data-cy": "cannot-generate-alert"
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" All prior steps (1–5) must be completed before you can generate the settlement statement. ", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(AlertBar, {
                      type: "info",
                      class: "mb-4",
                      "data-cy": "generation-info-alert"
                    }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" Generating the statement will lock the settlement and produce a PDF. You can unlock and reset afterwards if changes are needed. ", -1)
                      ]))]),
                      _: 1
                    }),
                    (__props.previewGenerating || __props.previewPolling)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_v_progress_circular, {
                            indeterminate: "",
                            color: "blue",
                            size: "48"
                          }),
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-body-1 font-weight-medium" }, "Generating statement preview…", -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "text-caption text-grey" }, " This usually takes a few seconds. ", -1))
                        ]))
                      : (__props.previewTimedOut)
                        ? (_openBlock(), _createBlock(AlertBar, {
                            key: 2,
                            class: "mb-4",
                            "data-cy": "preview-timeout-alert"
                          }, {
                            default: _withCtx(() => [
                              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "font-weight-bold mb-1" }, "Preview taking longer than expected…", -1)),
                              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mb-2 text-body-2" }, " The preview PDF is still being generated. ", -1)),
                              _createVNode(LlSecondaryButton, {
                                color: "warning",
                                "data-cy": "retry-preview-button",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('retry-preview')))
                              }, {
                                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                  _createTextVNode(" Try again ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (__props.previewUrl)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_unref(VuePdfEmbed), { source: __props.previewUrl }, null, 8, ["source"])
                            ]))
                          : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(LlSecondaryButton, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('go-back'))),
                        "data-cy": "back-button"
                      }, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode(" ← Back ", -1)
                        ]))]),
                        _: 1
                      }),
                      (__props.canGenerate)
                        ? (_openBlock(), _createBlock(LlSecondaryButton, {
                            key: 0,
                            color: "primary",
                            loading: __props.saving,
                            "data-cy": "generate-button",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('generate')))
                          }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createTextVNode(" Generate Statement ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["loading"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ], 64))
    ]),
    _: 1
  }))
}
}

})